// @inheritedComponent ButtonBase
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Button } from '@empiriecom/module-components';
import React from 'react';
import styled from 'styled-components';
var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    padding: 0.688rem 1.9rem 0.625rem;\n    border: 0.0625rem solid ", " !important;\n    background-image: none;\n\n    &:focus,\n    &:hover,\n    &.active {\n      background-color: ", ";\n      background-image: none;\n    }\n  }\n"], ["\n  &&& {\n    padding: 0.688rem 1.9rem 0.625rem;\n    border: 0.0625rem solid ", " !important;\n    background-image: none;\n\n    &:focus,\n    &:hover,\n    &.active {\n      background-color: ", ";\n      background-image: none;\n    }\n  }\n"])), function (_a) {
    var greyNormal = _a.theme.greyNormal;
    return greyNormal.color.normal;
}, function (_a) {
    var greyNormal = _a.theme.greyNormal;
    return greyNormal.color.normal;
});
var ToggleButton = function (props) {
    var _a = props, children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onChange = _a.onChange, onClick = _a.onClick, selected = _a.selected, value = _a.value;
    var handleChange = function (event) {
        event.preventDefault();
        if (onClick) {
            onClick(event, value);
            if (event.isDefaultPrevented()) {
                return;
            }
        }
        if (onChange) {
            onChange(event, value);
        }
    };
    return (React.createElement(StyledButton, { disabled: disabled, className: selected && 'active', onClick: handleChange, onChange: onChange, value: value, "aria-pressed": selected, noRipple: true },
        React.createElement("span", null, children)));
};
export default ToggleButton;
var templateObject_1;
//# sourceMappingURL=index.js.map